<template>
<div id="container">
  <div class="right-btn">
    <div class="pageNum">
      <input v-model.number="currentPage"
              type="number"
              class="inputNumber"
              @input="inputEvent()"> / {{ pageCount }}
    </div>
    <div @click="changePdfPage('first')"
          class="turn">
      首頁
    </div>
    <div @click="changePdfPage('pre')"
          class="turn-btn"
          :style="currentPage===1?'cursor: not-allowed;':''">
      上一頁
    </div>
    <div @click="changePdfPage('next')"
          class="turn-btn"
          :style="currentPage===pageCount?'cursor: not-allowed;':''">
      下一頁
    </div>
    <div @click="changePdfPage('last')"
          class="turn">
      最後頁
    </div>
  </div>
  <div class="pdfArea">
    <pdf :src="src"
          ref="pdf"
          :page="currentPage"
          @num-pages="pageCount=$event"
          @progress="loadedRatio = $event"
          @page-loaded="currentPage=$event"
          @loaded="loadPdfHandler"
          @link-clicked="currentPage=$event"
          style="display: inline-block; width:100%;"
          id="pdfID">
          </pdf>>
  </div>
</div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  components: {
    pdf
  },
  data () {
    return {
      src: '../../static/t.pdf',
      currentPage: 0,
      pageCount: 0,
      intervalID: ''
    }
  },
  destroyed () {
    clearInterval(this.intervalID)
  },
  methods: {
    listenerFunction (e) {
      document.getElementById('container').addEventListener('scroll', true)
    },
    toTop () {
      document.getElementById('container').scrollTop = 0
    },
    inputEvent () {
      if (this.currentPage > this.pageCount) {
        this.currentPage = this.pageCount
      } else if (this.currentPage < 1) {
        this.currentPage = 1
      }
    },
    changePdfPage (val) {
      if (val === 'pre' && this.currentPage > 1) {
        this.currentPage--
        this.toTop()
      } else if (val === 'next' && this.currentPage < this.pageCount) {
        this.currentPage++
        this.toTop()
      } else if (val === 'first') {
        this.currentPage = 1
        this.toTop()
      } else if (val === 'last' && this.currentPage < this.pageCount) {
        this.currentPage = this.pageCount
        this.toTop()
      }
    },
    loadPdfHandler (e) {
      this.currentPage = 1
    }
  }
}
</script>

<style scoped>
#container {
  overflow: auto;
  height: 700px;
  width: 100%;
  display: flex;
  position: relative;
}
.right-btn {
  position:fixed;
  width: 120px;
  flex-wrap: wrap;
  justify-content: center;
  z-index: 99;
}
.pdfArea {
  width: 80%;
}
.pageNum {
  margin: 10px 0;
  font-size: 1rem;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}
.inputNumber {
  border-radius: 8px;
  border: 1px solid #999999;
  height: 35px;
  font-size: 1rem;
  width: 60px;
  text-align: center;
}
.inputNumber:focus {
  border: 1px solid #00aaff;
  background-color: rgba(18, 163, 230, 0.09);
  outline: none;
  transition: 0.2s;
}
.turn{
  background-color: #888888;
  opacity: 0.7;
  color: #ffffff;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px 0;
  font-size: 0.8rem;
}
.turn-btn {
  background-color: #000000;
  opacity: 0.7;
  color: #ffffff;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px 0;
  font-size: 0.8rem;
}
.turn-btn:hover,
.turn:hover {
  transition: 0.3s;
  opacity: 0.5;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pdfOverview.vue